const priceContracts: {cakeAddress: string, busdAddress: string, lpAddress:string} = {
  cakeAddress: '0xE427bb1d14553f6DE5FE64466cdf69669572A54b',
  busdAddress: '0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56',
  lpAddress: '0xcE37B50B2538C648a251AdC48f290b80F6bc1C2c'
}

export default priceContracts
